import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { LoginUsuarioComponent } from './pages/login-usuario/login-usuario.component';
import { EmailSenhaComponent } from './pages/recuperar-senha/email-senha/email-senha.component';
import { EsqueciSenhaComponent } from './pages/recuperar-senha/esqueci-senha/esqueci-senha.component';
import { appGuard } from './services/auth.guard';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { motoristaRoutes } from './motoristaExterno.routes';
import { empresaRoutes } from './empresa.routes';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginUsuarioComponent },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [appGuard]
  },
  { path: 'recuperar-senha', component: EmailSenhaComponent },
  { path: 'esqueci-senha', component: EsqueciSenhaComponent },
  ...motoristaRoutes,
  ...empresaRoutes,
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
